// Singleton factory for diktat-lyd.
//
// VITE_DICTATION_AUDIO:
//   webspeech   — kun browser TTS (default)
//   prerendered — public/audio/da/*.mp3 med fallback til Web Speech

import type { DictationAudio } from './dictationAudio';
import { PrerenderedAudio } from './prerenderedAudio';
import { WebSpeechAudio } from './webSpeechAudio';

export type { DictationAudio, DictationVoice, DictationSpeakOptions } from './dictationAudio';
export { getDictationWordManifest, getDictationAudioManifest } from '../../data/curriculum/dictationWords';

let instance: DictationAudio | null = null;

function createDictationAudio(): DictationAudio {
  const mode = import.meta.env.VITE_DICTATION_AUDIO?.toLowerCase();
  if (mode === 'prerendered' || mode === 'elevenlabs') {
    return new PrerenderedAudio();
  }
  return new WebSpeechAudio();
}

export function getDictationAudio(): DictationAudio {
  if (!instance) {
    instance = createDictationAudio();
  }
  return instance;
}

/** Test-helper to swap the implementation. */
export function __setDictationAudioForTests(impl: DictationAudio | null): void {
  instance = impl;
}
